function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "{title}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21,16V8a2,2,0,0,0-1-1.73l-7-4a2,2,0,0,0-2,0l-7,4A2,2,0,0,0,3,8v8a2,2,0,0,0,1,1.73l7,4a2,2,0,0,0,2,0l7-4A2,2,0,0,0,21,16Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  points: "3.27 6.96 12 12.01 20.73 6.96"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 22.08,
  x2: 12,
  y2: 12
});

var _ref6 = /*#__PURE__*/React.createElement("polyline", {
  points: "3.27 11.96 12 17.01 20.73 11.96"
});

var SvgComponent = function SvgComponent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/apps.73f8311c.svg";
export { SvgComponent as ReactComponent };